var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page",attrs:{"id":"app"}},[_c('router-view'),_c('YunTiUinLoginTip',{attrs:{"show":_vm.showTips},on:{"update:show":function($event){_vm.showTips=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }